import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Center } from '@core/interfaces/tenant-state';

@Component({
  name: 'bpc-image-upload-modal',
  components: {
    'bpc-std-form': StdForm,
  },
})
export default class ImageUploadModal extends Vue {
  $refs: {
    stdUploadImageForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
    };
  };
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'global.upload_image' }) readonly modalTitle: string;

  public formModel: Center = null;
  public key: number = 0;
  public disableAcceptButton: boolean = true;

  get uploadImagePath() {
    return `${this.$bpcApiRouteHelper.getEntityPath('center')}/image/upload`;
  }

  close() {
    this.$emit('click-on-close');
  }

  async onUploadImage() {
    this.disableAcceptButton = true;
    const image = await this.$refs.stdUploadImageForm.saveEntity();
    await this.$emit('click-on-upload', image);
    this.disableAcceptButton = false;
  }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    if (this.formModel?.images) {
      this.disableAcceptButton = false;
    }
  }
}
